var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomercare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.961 23.7421C19.2108 23.4445 21.0613 21.7056 21.4628 19.5178C21.5069 19.2772 21.5252 19.0289 21.5263 18.7841C21.5322 17.3682 21.4991 15.9515 21.5361 14.5366C21.6004 12.0829 20.0264 10.1915 17.9486 9.52174C15.7759 8.82136 13.768 9.17097 12.0495 10.7237C11.0001 11.672 10.4842 12.8924 10.4725 14.3091C10.4611 15.6809 10.471 17.0528 10.4694 18.4248C10.4684 19.3021 9.87293 19.9 8.99338 19.8985C8.69554 19.898 8.39624 19.9314 8.09934 19.8614C7.43252 19.7042 7.00227 19.1792 7.0013 18.5006C6.99943 17.1814 6.99972 15.8623 7.00126 14.5431C7.00221 13.7257 7.58994 13.1314 8.40971 13.1148C8.48892 13.1131 8.56906 13.1065 8.64724 13.1155C8.82054 13.1353 8.901 13.0548 8.94271 12.8924C9.663 10.0889 11.5044 8.39741 14.2618 7.7176C17.4324 6.93592 20.7835 8.30393 22.3839 11.1194C22.677 11.6349 22.905 12.1809 23.0224 12.7583C23.0848 13.0651 23.2187 13.1252 23.4984 13.1208C24.2474 13.1088 24.7648 13.4958 24.9621 14.1686C24.9978 14.2905 24.9993 14.411 24.9993 14.5336C25 15.8439 25.0004 17.1543 24.9995 18.4646C24.999 19.2773 24.4046 19.8842 23.5956 19.9007C23.1185 19.9104 23.1256 19.9124 22.9976 20.3667C22.381 22.5563 20.9727 24.0444 18.9047 24.9328C17.9895 25.326 17.028 25.5162 16.0282 25.4989C15.5345 25.4904 15.155 25.1347 15.15 24.6682C15.1449 24.2063 15.5292 23.8273 16.0201 23.8276C16.3295 23.8278 16.6329 23.7798 16.961 23.7421Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1443 19.651C18.3215 19.8783 18.3084 20.1003 18.2112 20.3367C17.8446 21.228 16.9644 21.8052 15.9666 21.8019C15.0231 21.7988 14.1354 21.1946 13.7881 20.3193C13.6006 19.8467 13.8694 19.4033 14.3793 19.3967C15.4602 19.3826 16.5415 19.391 17.6226 19.3952C17.8242 19.396 17.9967 19.4812 18.1443 19.651Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomercare);
export default __webpack_public_path__ + "static/media/customercare.cf41f871697101529e833807fed1a24c.svg";
export { ForwardRef as ReactComponent };